import JsonManager from './JsonManager';

const imageExtention = '.jpg';
const pngExtention = '.png';

class ImageManager {
  constructor(id, filePath = '') {
    this.id = id;
    this.project = JsonManager.getProject(id);
    try {
      this.largeImagesPath = filePath + JsonManager.getImagesPath('large');
      this.thumbanailImagesPath = filePath + JsonManager.getImagesPath('thumbs');
      this.titleImagesPath = filePath + JsonManager.getImagesPath('title');
      this.tinyImagePath = filePath + JsonManager.getImagesPath('tiny');
      this.iconImagePath = filePath + JsonManager.getImagesPath('icons');
    } catch (err) {
      console.log(err);
    }
  }

  getBannerImage() {
    return this.getProjectImageByIndex(this.largeImagesPath, 0);
  }

  getProjectTinyImageAt(Index) {
    return this.getProjectImageByIndex(this.tinyImagePath, Index);
  }

  getProjectThumbnailImageAt(Index) {
    return this.getProjectImageByIndex(this.thumbanailImagesPath, Index);
  }

  getProjectLargeImageAt(Index) {
    return this.getProjectImageByIndex(this.largeImagesPath, Index);
  }

  getProjectTitleImage() {
    return this.getProjectImageById(this.titleImagesPath);
  }

  getProjectTinyTitleImage() {
    return this.getProjectImageById(this.tinyImagePath);
  }

  getDefaultImage() {
    const mainImage = 'CheesyBit_1';
    return this.largeImagesPath + mainImage + imageExtention;
  }

  getIconImage(iconName) {
    const mainImage = JsonManager.getIcon(iconName);
    return this.iconImagePath + mainImage + pngExtention;
  }

  getProjectImageByIndex(imagePath, index) {
    const mainImage = `${this.project.image_id}_${this.project.content[index]}`;
    return imagePath + mainImage + imageExtention;
  }

  getProjectImageById(imagePath) {
    const mainImage = this.project.image_id;
    return imagePath + mainImage + imageExtention;
  }
}

export default ImageManager;



// WEBPACK FOOTER //
// ./src/managers/ImageManager.js